import type { StepThreeFormSchema } from '../validations/add-template.validation';

const cloneFileFieldForSnapshot = (
  file: StepThreeFormSchema['file'],
): StepThreeFormSchema['file'] => {
  if (file == null) return file;
  if (file instanceof File) return file;
  if (typeof file === 'object' && 'doc' in file) {
    const { abort: _abort, ...rest } = file;
    return rest;
  }
  return file;
};

export const cloneStepThreeSnapshot = (stepThree: StepThreeFormSchema): StepThreeFormSchema => {
  return structuredClone({
    ...stepThree,
    file: cloneFileFieldForSnapshot(stepThree.file),
  });
};
